<template>
  <div class="park">
    <div>
    <div class="park-btn">
      <el-button type="primary" size="mini" @click="updateDicDialog()">添加数据</el-button>
    </div>
    <div class="park-btn">
      <span class="f14 bold">字典类型：</span>
        <el-radio v-model="dataArgs.type" :label=null @change="changeTypeRadio()">全部</el-radio>
      <div>
      <span class="f14 bold">页面字典：</span>
      <template v-for="item in dicTypeList">
        <el-radio v-model="dataArgs.type" :label="item.code" @change="changeTypeRadio()" v-if="item.code.indexOf('page')!=-1">{{item.name}}</el-radio>
      </template>
      </div>
      
      <div>
      <span class="f14 bold">其他字典：</span>
      <template v-for="item in dicTypeList">
        <el-radio v-model="dataArgs.type" :label="item.code" @change="changeTypeRadio()" v-if="item.code.indexOf('other')!=-1">{{item.name}}</el-radio>
      </template>
      </div>
    </div>
    <div class="park-btn">
      <span class="f14 bold">数据状态：</span>
      <el-radio v-model="dataArgs.status" :label='-1' @change="changeTypeRadio()">全部</el-radio>
      <el-radio v-model="dataArgs.status" :label='0' @change="changeTypeRadio()">失效</el-radio>
      <el-radio v-model="dataArgs.status" :label='1' @change="changeTypeRadio()">有效</el-radio>
    </div>
    <div class="main-table">
      <el-table
        :data="dicList"
        border
        style="width: 100%">
        <el-table-column prop="id" label="ID"> </el-table-column>
        <el-table-column prop="type" label="类别"> </el-table-column>
        <el-table-column prop="code" label="编码"> </el-table-column>
        <el-table-column prop="name" label="名称"> </el-table-column>
        <el-table-column prop="sort" label="顺序"> </el-table-column>
        <el-table-column label="创建日期">
          <template slot-scope="scope">
            <div>{{$dtime(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">有效</el-tag>
            <el-tag type="danger" v-else>已失效</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="updateDicDialog(scope.row)">修改</el-button>
            <!--<el-button type="text" size="mini" @click="deleteDicDialog(scope.row)">{{scope.row.isDelete == true ? '恢复':'删除'}}</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-bottom:30px;margin-top:20px;">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="dataArgs.total"
          :page-size="dataArgs.take"
          :current-page="dataArgs.skip/dataArgs.take+1"
          @current-change="changePage" style="float:right;">
        </el-pagination>
      </div>
    </div>
    </div>
    <el-dialog
      title="字典操作"
      :visible.sync="isUpdateShow"
      width="70%">
      <el-form ref="form" :model="dicEntity" label-width="80px">
        <el-form-item label="类别">
          <el-input v-model="dicEntity.type"></el-input>
        </el-form-item>
        <el-form-item label="编码">
          <el-input v-model="dicEntity.code"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="dicEntity.name"></el-input>
        </el-form-item>
        <el-form-item label="顺序编号">
          <el-input v-model="dicEntity.sort"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model='dicEntity.status'>
            <el-option label="有效" :value="parseInt(1)"></el-option>
            <el-option label="失效" :value="parseInt(0)"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isUpdateShow = false">取 消</el-button>
        <el-button type="primary" @click="updateDic">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="!dicEntity.isDelete ? '删除字典':'恢复删除'"
      :visible.sync="isDeleteShow"
      width="50%">
      <span>确定要{{!dicEntity.isDelete ? '删除字典':'恢复删除'}}么？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDeleteShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteDic">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getUserDictionaries,updateUserDictionary,addUserDictionary} from './userDictionary.gql'
import gql from "graphql-tag";
export default {
  name: 'dic',
  data () {
    return {
      dicEntity:{
        name:null,
        type:null,
        code:null,
        sort:null,
        status:null,
      },
      dicTypeList:null,
      dicList:null,
      dataArgs:{
        take:20,
        skip:0,
        order:'-createTime',
        type:null,
        count:null,
        status:-1,
      },
      isUpdateShow:false,
      isDeleteShow:false,
    }
  },
  created(){
    this.getDicList()
    this.getDicTypeList()
  },
  methods:{
    getDicTypeList(){
      this.$global.GraphqlQuery(this,getUserDictionaries,{
        // query: gql`query getUserDictionaries($order: String, $skip: Int = 0, $status: Int = 1, $take: Int, $type: String) {
        //   getUserDictionaries(order: $order, skip: $skip, status: $status, take: $take, type: $type){
        //     status,
        //     data {
        //       id,
        //       code,
        //       type,
        //       name,
        //       sort,
        //       status,
        //       createTime
        //     },
        //     total
        //   }
        // }`,
        // Parameters
        type:'other_dictionary',order:'+sort'
      }).then((res) => {
        this.dicTypeList = res.data
      })
    },
    getDicList(){
      this.$global.GraphqlQuery(this,getUserDictionaries,
        // query: gql`query getUserDictionaries($order: String, $skip: Int = 0, $status: Int = 1, $take: Int, $type: String) {
        //   getUserDictionaries(order: $order, skip: $skip, status: $status, take: $take, type: $type){
        //     status,
        //     data {
        //       id,
        //       code,
        //       type,
        //       name,
        //       sort,
        //       status,
        //       createTime
        //     },
        //     total
        //   }
        // }`,
        // Parameters
    this.dataArgs,
      ).then((res) => {
        this.dataArgs.total = res.total
        this.dicList = res.data
        this.isUpdateShow = false
      })
    },
    updateDicDialog(item){
      if(item){
        this.dicEntity = item
      }else {
        this.dicEntity.id = null
      }
      this.isUpdateShow = !this.isUpdateShow
    },
    changeTypeRadio(){
      this.dataArgs.skip = 0;
      this.getDicList()
    },
    changePage(val){
      this.dataArgs.skip = (val-1)*this.dataArgs.take
      this.getDicList()
    },
    updateDic(){
      let {code,type,name,sort,status} = this.dicEntity
      const subEntity = {code,type,name,sort,status}
      
      if(this.dicEntity.id){
        this.$global.GraphqlMutation(this,updateUserDictionary,{
          // mutation: gql`mutation ($id:String! ,$data: UserDictionaryInput!) {
          //   updateUserDictionary(id:$id, data: $data) {
          //     status
          //   }
          // }`,
          // Parameters
          // variables: {
            id:this.dicEntity.id,
            data: subEntity
          // },
        }).then(res=>{
          this.getDicList();
        })
      } else {
        this.$global.GraphqlMutation(this,addUserDictionary,{
          // mutation: gql`mutation ($data: UserDictionaryInput!) {
          //   addUserDictionary(data: $data) {
          //     status
          //   }
          // }`,
          // Parameters
            data: subEntity,
        }).then(res=>{
          this.getDicList();
        })
      }
    },
    deleteDicDialog(item){
      this.dicEntity = item
      this.isDeleteShow = !this.isDeleteShow
    },
    deleteDic(){
    this.$apollo.mutate({
        mutation: gql`mutation ($id: String!) {
          deleteUserDictionary(id: $id) {
            status
          }
        }`,
        // Parameters
        variables: {
          id: 1,
        },
      }).then((res) => {
        console.log(res)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.park{
  height: 100%;
}
.park-btn {
  margin: 10px;
}
.park-red {
  background-color: red;
  color:white;
  padding:5px;
}
.park-green{
  background-color: green;
  color: white;
  padding:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/configuration/UserDictionary.vue